<template>
    <b-modal
            id="bdPopup"
            title="Inkomen ophalen bij Belastingdienst"
            size="lg"
            ok-title="Sluiten"
            ok-variant="success"
            @ok="$bvModal.hide('bdPopup')"
            ok-only
            hide-header-close
    >
        <b-row>
            <b-col>
                <p>
                    U kunt uw inkomensverklaring (IB60) zelf downloaden in Mijn Belastingdienst. U kunt ook een kopie maken van uw aanslag inkomstenbelasting. Dat is vaak ook goed.
                    <br/>
                    Downloaden doet u zo:
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <p>
                    U kunt uw exacte jaarinkomen vinden op uw Inkomensverklaring. U kunt deze opvragen bij de Belastingdienst. Dit doet u als volgt:
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <ol>
                    <li>
                        <p>
                            Log in op Mijn Belastingdienst: <a href="https://mijn.belastingdienst.nl/mbd-pmb/pmb.html" target="_blank">Mijn Belastingdienst</a>.
                        </p>
                    </li>
                    <li>
                        <p>
                            Klik op 'Mijn gegevens'.
                        </p>
                    </li>
                    <li>
                        <p>
                            Klik op ‘Inkomensverklaring opvragen en geregistreerd inkomen bekijken’.
                        </p>
                    </li>
                    <li>
                        <p>
                            Klik vervolgens op ‘Inkomensverklaring opvragen’ bij het jaar waarvoor u een inkomensverklaring wilt. Indien {{bdYear}} al beschikbaar is, kiest u daarvoor, anders voor {{bdYear-1}}.
                        </p>
                    </li>
                    <li>
                        <p>
                            Er opent een PDF die u kunt opslaan. <i>Let op: U kunt dit document direct uploaden als Inkomensverklaring in de stap "Uw Documenten".</i>
                        </p>
                    </li>
                    <li>
                        <p>
                            In het document wat u zojuist hebt opgeslagen staat "Verzamelinkomen" gevolgd door een bedrag. Vul dit bedrag zonder Euro-teken en punt in bij 'Inkomen per jaar'.
                        </p>
                    </li>
                </ol>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <p>
                    <i>
                        U kunt veilig naar de website van de belastingdienst doorklikken. Woonmatch verwijst u naar de belastingdienst, maar kan niet voor u inloggen of de gegevens van de belastingdienst gebruiken.
                    </i>
                </p>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
    export default {
        name: 'BdPopup',
        data: () => {
          return {
            bdYear: new Date().getFullYear()
          }
        }
    }
</script>